// extracted by mini-css-extract-plugin
module.exports = {"mainButtonStyle":"buttonStyle_mainButtonStyle__2Rig2","buttonSuccessStyle":"buttonStyle_buttonSuccessStyle__2A5S0"};